import { render } from "./WeekendSubscription.vue?vue&type=template&id=e98a07e4&scoped=true"
import script from "./WeekendSubscription.vue?vue&type=script&lang=js"
export * from "./WeekendSubscription.vue?vue&type=script&lang=js"

import "./WeekendSubscription.vue?vue&type=style&index=0&id=e98a07e4&scoped=true&lang=css"

import exportComponent from "/home/user/devops/sourcecode/Sopecam/sopecam-cameroontribune-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e98a07e4"]])

export default __exports__